import React, { createContext, useContext, useState, useEffect } from 'react';
import { setEnvironmentMode, getConfig } from '../config/environmentConfig';

const SettingsContext = createContext();

export function SettingsProvider({ children }) {
  const [useAI, setUseAI] = useState(() => {
    const stored = localStorage.getItem('useAI');
    return stored !== null ? stored === 'true' : true;
  });

  const [useEnhancedAI, setUseEnhancedAI] = useState(() => {
    const stored = localStorage.getItem('useEnhancedAI');
    return stored !== null ? stored === 'true' : true;
  });

  // Add mode: 'production' or 'greenfield'
  const [ehrMode, setEhrMode] = useState(() => {
    const stored = localStorage.getItem('ehrMode');
    return stored || 'production';
  });

  // Add units preference: 'metric' or 'imperial'
  const [units, setUnits] = useState(() => {
    const stored = localStorage.getItem('units');
    return stored || 'metric';
  });

  useEffect(() => {
    localStorage.setItem('useAI', useAI);
  }, [useAI]);

  useEffect(() => {
    localStorage.setItem('useEnhancedAI', useEnhancedAI);
  }, [useEnhancedAI]);

  useEffect(() => {
    if (ehrMode) {
      localStorage.setItem('ehrMode', ehrMode);
      // Update environment configuration when ehrMode changes
      setEnvironmentMode(ehrMode);
    }
  }, [ehrMode]);

  useEffect(() => {
    localStorage.setItem('units', units);
  }, [units]);

  return (
    <SettingsContext.Provider
      value={{
        useAI,
        setUseAI,
        useEnhancedAI,
        setUseEnhancedAI,
        ehrMode,
        setEhrMode,
        units,
        setUnits,
        // Expose environment config through settings context
        environmentConfig: getConfig(),
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext);
}
